// extracted by mini-css-extract-plugin
export default {"container":"Login_container__KEHRh","loginH1":"Login_loginH1__5FIrf","loginButton":"Login_loginButton__9nDSA","spotifyImage":"Login_spotifyImage__mhcDS"};